import { render } from "./theme22.vue?vue&type=template&id=43078a0a&scoped=true"
import script from "./theme22.vue?vue&type=script&lang=js"
export * from "./theme22.vue?vue&type=script&lang=js"

import "./theme22.vue?vue&type=style&index=0&id=43078a0a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-43078a0a"

export default script